import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  QuickFilter,
  QuickFilterClear,
  QuickFilterControl
} from '@mui/x-data-grid';
import { Box, Button, IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { ReactNode } from 'react';
import { DownloadIcon, UserWithBadgeIcon } from '../assets/icons/icons';

interface StyledToolBarProps {
  children?: ReactNode;
  onExport?: () => void;
  exportLoading?: boolean;
  onVerifyAll?: () => void;
  verifyAllLoading?: boolean;
  disableVerifyAll?: boolean;
}

const StyledToolBar = ({
  children,
  onExport,
  exportLoading,
  onVerifyAll,
  verifyAllLoading,
  disableVerifyAll
}: StyledToolBarProps): JSX.Element => {
  return (
    <GridToolbarContainer
      data-testid="custom-toolbar"
      sx={{ padding: 1, justifyContent: 'flex-start' }}
    >
      {children}
      <GridToolbarColumnsButton />
      {onVerifyAll && (
        <Button
          onClick={onVerifyAll}
          disabled={verifyAllLoading || !!disableVerifyAll}
          startIcon={<UserWithBadgeIcon />}
          sx={{ ml: 1 }}
        >
          Verify All
        </Button>
      )}
      {onExport && (
        <Button
          onClick={onExport}
          disabled={exportLoading}
          startIcon={<DownloadIcon />}
          sx={{ ml: 1 }}
        >
          Export CSV
        </Button>
      )}
      <Box sx={{ marginLeft: 'auto' }}>
        {/* Keep the search field open, as GridToolbarQuickFilter collapses to an icon in MUI X v8+ */}
        <QuickFilter expanded>
          <QuickFilterControl
            render={({ ref, slotProps, ...controlProps }) => (
              <TextField
                {...controlProps}
                inputRef={ref}
                variant='standard'
                placeholder='Search…'
                aria-label='Search'
                slotProps={{
                  ...slotProps,
                  input: {
                    ...slotProps?.input,
                    startAdornment: (
                      <InputAdornment position='start'>
                        <SearchIcon fontSize='small' />
                      </InputAdornment>
                    ),
                    endAdornment: controlProps.value ? (
                      <InputAdornment position='end'>
                        <QuickFilterClear
                          render={<IconButton size='small' edge='end' aria-label='Clear search' />}>
                          <ClearIcon fontSize='small' />
                        </QuickFilterClear>
                      </InputAdornment>
                    ) : null
                  }
                }}
              />
            )}
          />
        </QuickFilter>
      </Box>
    </GridToolbarContainer>
  );
};

export default StyledToolBar;